import { useEffect, useState } from "react";
import { PlayerGetCurrentInfoUseCase } from "../../../../domain/usecase/player/GetCurrentInfo/GetCurrentInfoUseCase";
import { Player } from "../../../../domain/model/User";
import { State } from "../../../../domain/model/ResponseState";
import { useSnackbar } from "notistack";
import { useLocation, useNavigate } from "react-router-dom";

export function UserInfoViewModel(
  playerGetCurrentInfoUseCase: PlayerGetCurrentInfoUseCase,
) {
  const { enqueueSnackbar } = useSnackbar();
  const [player, setPlayer] = useState<Player | undefined>();

  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    getCurrentInfo();
  }, []);

  async function getCurrentInfo() {
    const response = await playerGetCurrentInfoUseCase.invoke();
    switch (response.responseState) {
      case State.Success:
        if (!response.data) return;
        setPlayer(response.data);
        break;
      case State.Fail:
      case State.Error:
        showSnackbar(response.error?.message);
        break;
    }
  }

  function showSnackbar(
    message: string | undefined,
    variant: "error" | "success" = "error",
  ) {
    if (message) enqueueSnackbar(message, { variant: variant });
  }
  return { player, getCurrentInfo };
}
